// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + "85e8d9edc3ca4eb4fb5b" + ".js";
};